import React from 'react';
import {EventStore, ScrollData} from './store';

interface Props {
  children?: React.ReactNode;
}

export default class ScrollProvider extends React.PureComponent<Props> {
  timeout: NodeJS.Timeout | null = null;
  scrollData: ScrollData = {scrollTop: 0, scrollHeight: 0, clientHeight: 0};

  handleWheel = (): void => {
    const rootDom = document.documentElement;
    this.scrollData = {
      scrollTop: rootDom.scrollTop,
      scrollHeight: rootDom.scrollHeight,
      clientHeight: rootDom.clientHeight,
    };
    if (!this.timeout) {
      this.timeout = setTimeout(() => {
        EventStore.emit(this.scrollData);
        this.timeout = null;
      }, 100);
    }
  };
  render(): JSX.Element {
    const {children} = this.props;
    return (
      <div onWheel={this.handleWheel} style={{width: '100%'}}>
        {children}
      </div>
    );
  }
}
